import type { TFunction } from "i18next";
import type { PromptLlmModel } from "@nexus/contracts";

const MICROS_PER_USD = 1_000_000;

function usdPerMillion(micros: number): string {
  return (micros / MICROS_PER_USD).toLocaleString(undefined, {
    minimumFractionDigits: 0,
    maximumFractionDigits: 2,
  });
}

/** List-price badge for the model picker; null when both rates are absent. */
export function promptModelPriceMeta(
  t: TFunction,
  model: Pick<PromptLlmModel, "inputPerMillion" | "outputPerMillion">,
): string | undefined {
  const { inputPerMillion, outputPerMillion } = model;
  if (inputPerMillion == null && outputPerMillion == null) return undefined;
  if (inputPerMillion == null || outputPerMillion == null) {
    return t("prompts.editor.model.needsRate", "Needs a rate");
  }
  return t("prompts.editor.model.pricePerMillion", "${{input}} / ${{output}} per 1M", {
    input: usdPerMillion(inputPerMillion),
    output: usdPerMillion(outputPerMillion),
  });
}
